import { useState } from 'react'
import { Link } from 'react-router-dom'

import * as Yup from 'yup'
import { useFormik } from 'formik'

import { useDispatch } from 'react-redux'
import { setTokenSession } from '../../redux/slices/session.slice'

import { authService } from 'services/auth.services'

import { routes } from 'utils/routes'
import { useRenderLogger } from 'utils'

import { Button, InputField } from 'components/form-inputs'

import { Logo } from 'assets/images'
import { _object } from 'utils/interfaces'
import SeoHead from 'components/meta-tags'

const Login = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState<_object>({})
  useRenderLogger('Login')

  const validationSchema = Yup.object({
    email: Yup.string().label('Email').required(),
    password: Yup.string().label('Password').min(4).required()
  })

  const formik: any = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      authService.login(values).then((results: { error: boolean; access_token: string }) => {
        setResult(results)
        setLoading(false)
        if (results?.error === false && results?.access_token) {
          dispatch(setTokenSession(results?.access_token))
          setTimeout(() => {
            window.location.href = routes.dashboard
          }, 1000)
        }
      })
    }
  })

  return (
    <>
      <SeoHead seoTitle={'Login'} />
      <div>
        <div className="flex h-[calc(100vh)] w-full flex-col items-center justify-center overflow-y-auto">
          <Link
            to="/"
            className="flex w-full max-w-sm justify-center rounded-t-lg bg-purple-900 p-2"
          >
            <img src={Logo} alt="Logo" />
          </Link>
          <div className="w-full max-w-sm rounded-lg border border-gray-200 bg-white p-6 shadow-2xs">
            <h2 className="mb-1 text-center text-lg font-bold text-purple-900">Login</h2>
            <p className="mb-4 text-center text-base text-gray-900">Sign in to your account</p>

            <form onSubmit={formik.handleSubmit}>
              <InputField
                name="email"
                type="email"
                placeholder="Email"
                onChange={formik.handleChange}
                value={formik.values.email}
                onBlur={formik.handleBlur}
                required={true}
                error={formik.touched.email && formik.errors.email}
              />

              <InputField
                name="password"
                type="password"
                placeholder="Password"
                onChange={formik.handleChange}
                value={formik.values.password}
                onBlur={formik.handleBlur}
                required={true}
                error={formik.touched.password && formik.errors.password}
              />
              <p className="m-0 text-end">
                <Link
                  className="text-bg-purple-900 mb-2 cursor-pointer text-right text-sm hover:underline"
                  to="/forgot-password"
                >
                  Forgot Password?
                </Link>
              </p>
              <Button
                label="Login"
                type="submit"
                className="mt-4 flex w-full justify-center rounded-lg bg-purple-900 py-2 text-center text-sm text-white transition hover:bg-purple-950"
                loading={loading}
                disabled={!formik.isValid}
              />
              {result?.error && (
                <p className="mt-2 text-center text-sm text-red-600">{result.message}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
export default Login
